export default [
    {
      path: '',
      name: 'memberHome',
      meta: {
        title: '会员首页'
      },
      component: () => import('@/views/member/index.vue')
    },
    {
      path: 'buy',
      name: 'memberBuy',
      meta: {
        title: '会员购买'
      },
      component: () => import('@/views/member/buy.vue')
    },
    {
      path: 'password',
      name: 'memberPassword',
      meta: {
        title: '支付密码'
      },
      component: () => import('@/views/member/password.vue')
    },
    {
      path: 'result',
      name: 'memberResult',
      meta: {
        title: '支付'
      },
      component: () => import('@/views/member/payResult.vue')
    },
  ]
  